import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const useSegmentId = () => {
  const user = useSelector((state) => state.oidc.user);

  const [segmentId, setSegmentId] = useState(process.env.REACT_APP_TENANT_ID);

  useEffect(() => {
    if (user?.profile && user?.profile['custom:catalog_id']) {
      const catalogId = user?.profile['custom:catalog_id'];
      const segments = process.env.REACT_APP_MENU_SEGMENTS || '1';
      const segmentsArray = segments.split(',');

      if (segmentsArray.includes(catalogId)) {
        setSegmentId(catalogId);
      }

      if (segmentsArray.length === 1) {
        setSegmentId(segmentsArray[0]);
      }
    }
  }, [user]);

  return { segmentId };
};

export default useSegmentId;
